import { Typography } from "@material-ui/core";
import React from "react";

function ReturnRefund(props) {
  return (
    <React.Fragment>
      <Typography paragraph variant="h5">
        Return & Refund Policy
      </Typography>
      <Typography paragraph variant="body1">
        Updated at 2022-02-02
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Definitions and key terms
      </Typography>
      <Typography paragraph variant="body1">
        To help explain things as clearly as possible in this Return & Refund
        Policy, every time any of these terms are referenced, are strictly
        defined as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Company</b>: when this policy mentions "Company," "we," "us," or
            "our," it refers to Invifo Technology International, Level 11, One
            Pacific Place, Sudirman Central Business District, Kav 52 - 53,
            Jakarta Selatan 12190, Indonesia that is responsible for your
            information under this Privacy Policy.
          </li>
          <li>
            <b>Customer</b>: refers to the company, organization or person that
            signs up to use the Invifo Service to manage the relationships with
            your consumers or service users.
          </li>
          <li>
            <b>Device</b>: any internet connected device such as a phone,
            tablet, computer or any other device that can be used to visit
            Invifo and use the services.
          </li>
          <li>
            <b>Service</b>: refers to the service provided by Invifo as
            described in the relative terms (if available) and on this platform.
          </li>
          <li>
            <b>Website</b>: Invifo's site, which can be accessed via this URL:
            https://invifo.com.
          </li>
          <li>
            <b>You</b>: a person or entity that is registered with Invifo to use
            the Services.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Shipping
      </Typography>
      <Typography paragraph variant="body1">
        Invifo is not responsible for return shipping costs. Every shipping has
        to be paid by the customer, even if the item had free shipping in the
        first place, the customer has to pay for the shipping in return.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Return & Refund Policy
      </Typography>
      <Typography paragraph variant="body1">
        Thanks for shopping at Invifo. We appreciate the fact that you like to
        buy the stuff we build. We also want to make sure you have a rewarding
        experience while you're exploring, evaluating, and purchasing our
        products.
      </Typography>
      <Typography paragraph variant="body1">
        As with any shopping experience, there are terms and conditions that
        apply to transactions at Invifo. We'll be as brief as our attorneys will
        allow. The main thing to remember is that by placing an order or making
        a purchase at Invifo, you agree to the terms set forth below along with
        Invifo's Privacy Policy.
      </Typography>
      <Typography paragraph variant="body1">
        If there's something wrong with the product you bought, or if you are
        not happy with it, you will not be able to issue a refund for your item.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Refunds
      </Typography>
      <Typography paragraph variant="body1">
        We at Invifo commit ourselves to serving our customers with the best
        products. Every single product that you choose is thoroughly inspected,
        checked for defects and packaged with utmost care. We do this to ensure
        that you fall in love with our products.
      </Typography>
      <Typography paragraph variant="body1">
        Sadly, there are times when we may not have the product(s) that you
        choose in stock, or may face some issues with our inventory and quality
        check. In such cases, we may have to cancel your order. You will be
        intimated about it in advance so that you don't have to worry
        unnecessarily about your order. If you have purchased via Online payment
        (not Cash on Delivery), then you will be refunded once our team confirms
        your request.
      </Typography>
      <Typography paragraph variant="body1">
        We carry out thorough quality check before processing the ordered item.
        We take utmost care while packing the product. At the same time we
        ensure that the packing is good such that the items won't get damaged
        during transit. Please note that Invifo is not liable for damages that
        are caused to the items during transit or transportation.
      </Typography>
      <Typography paragraph variant="body1">
        We follow certain policies to ensure transparency efficiency and quality
        customer care:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            We DO NOT allow returns on sold products - online or in retail
            outlets.
          </li>
          <li>
            We DO NOT accept returned goods, as we believe that customers should
            get the best quality products.
          </li>
          <li>
            Refunds are NOT given for any purchases made - be they online or in
            retail store.
          </li>
          <li>We DO NOT encourage exchanges of our products.</li>
          <li>
            We DO NOT engage in reselling used products and discourage the same,
            because we cannot ensure the best quality products for our
            customers.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        For International Orders:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>We DO NOT support Exchanges or Returns.</li>
          <li>
            If you cancel the order before we process it and dispatch for
            shipping, a refund can be processed. Orders generally take 1-2 days
            to process before dispatch.
          </li>
          <li>
            Orders already in shipping cannot be returned, canceled or refunded.
          </li>
          <li>
            If you face any issues, please contact our Support Team immediately.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Your Consent
      </Typography>
      <Typography paragraph variant="body1">
        By using our platform, registering an account, or making a purchase, you
        hereby consent to our Return & Refund Policy and agree to its terms.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Changes To Our Return & Refund Policy
      </Typography>
      <Typography paragraph variant="body1">
        Should we update, amend or make any changes to this document so that
        they accurately reflect our Service and policies. Unless otherwise
        required by law, those changes will be prominently posted here. Then, if
        you continue to use the Service, you will be bound by the updated Return
        & Refund Policy. If you do not want to agree to this or any updated
        Return & Refund Policy, you can delete your account.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Contact Us
      </Typography>
      <Typography paragraph variant="body1">
        If, for any reason, You are not completely satisfied with any good or
        service that we provide, don't hesitate to contact us and we will
        discuss any of the issues you are going through with our product.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Via Email: support@invifo.com</li>
          <li>Via this Link: https://www.invifo.com/contact-us</li>
        </ul>
      </Typography>
    </React.Fragment>
  );
}

export default ReturnRefund;
